export default __webpack_public_path__ + "static/media/61.5eb52e73.jpeg";